import * as React from 'react';
import * as firebase from 'firebase/app';
import { reduxForm, Field, InjectedFormProps, FieldArray } from 'redux-form';
import { Dispatch, connect } from 'react-redux';
import { AppState, State, Township, CollectionState, Contact, Category } from 'src/store';
import { TextField } from 'redux-form-antd';
import { CascaderField, TextAreaField, TreeSelectField, CheckboxField } from '../../reduxFormAntd';
import { actions as toast } from 'src/toast';
import { Button, Card, Row, Col, Form } from 'antd';
import { push } from 'react-router-redux';
import { RouteComponentProps } from 'react-router';
import { actions } from '../redux';
import { actions as stateActions } from '../../states/redux';
import { actions as townshipActions } from '../../townships/redux';
import { actions as categoryActions } from '../../categories/redux';
import { CascaderOptionType } from 'antd/lib/cascader';
import {
  ContactsTableProps,
  ContactsTable,
  ContactsTableRow,
} from '../containers';
import { TreeNode } from 'antd/lib/tree-select';
const FormItem = Form.Item;

const required = (value: string) => (value ? undefined : 'Required');

const trim = (value: string) => value && value.trim();

const idFormat = (value: string) => value && !/^[a-z0-9]+$/.test(value)
  ? 'must be alpha numeric (only lowercase)' : undefined;

const validateIDAsync = async ({ id }: FormData) => {
  if (id) {
    const ref = firebase.firestore().doc(`merchants/${id}`);
    const doc = await ref.get();
    if (doc.exists) {
      throw { id: 'That ID is already taken' };
    }
  }
};

const formItemLayout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 12 },
    sm: { span: 15 },
  },
};

const mapStateToProps = (appState: AppState, props: Props) => {
  const { merchantDetailState, statesState, townshipsState, categoriesState } = appState;
  const { match: { params: { id } } } = props;
  let initialValues: Partial<FormData> = { businessName: '', legacy: false, disabled: false, enableSubscription: false };
  if (id && merchantDetailState.status === 'loaded') {
    const {
      legacy,
      disabled,
      enableSubscription,
      businessName,
      contactName,
      email,
      phone,
      website,
      fbId,
      categories,
      address,
      township,
      state,
      contacts,
    } = merchantDetailState.data;

    const contactsData = contacts || [];
    const contactsRows = getInitialRows({ contacts: contactsData });
    const statetownship = state && township ? [state.code, township.code] : [];
    const categoryIds: string[] = [];
    if (categories && categories.length > 0) {
      categories.forEach((category) => {
        categoryIds.push(category.id)
      })
    }
    initialValues = {legacy, disabled, enableSubscription, businessName, contactName, email, phone, categoryIds, website, fbId, address, statetownship, contacts: contactsRows };
  }
  const loading = merchantDetailState.status === 'loading' ||
    (statesState.status !== 'loaded' && townshipsState.status === 'loaded');
  return {
    id,
    statesState,
    townshipsState,
    categoriesState,
    initialValues,
    loading,
  };
};
const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    listen: (id: string | null) => {
      if (id) {
        dispatch(actions.listenDoc(id));
      }
      dispatch(stateActions.listenCollection());
      dispatch(townshipActions.listenCollection());
      dispatch(categoryActions.listenCollection())
    },
    unlisten: () => {
      dispatch(actions.unlistenDoc());
      dispatch(stateActions.unlistenCollection());
      dispatch(townshipActions.unlistenCollection());
      dispatch(categoryActions.unlistenCollection());
    }
  };
};

const getInitialRows = (args: { contacts: Contact[] }) => {
  const { contacts } = args;

  const rows: ContactsTableRow[] = contacts.map((c, i) => {
    return {
      no: i + 1,
      key: i.toString(),
      ...c,
      editable: false,
    };
  });
  return rows;
};

interface FormData {
  id?: string;
  legacy: boolean;
  disabled: boolean;
  enableSubscription: boolean;
  businessName: string;
  contactName: string;
  email: string;
  phone: string;
  website: string;
  fbId: string;
  categoryIds: string[];
  address: string;
  statetownship: string[];
  contacts: ContactsTableRow[];
}

interface Props extends InjectedFormProps<FormData>, RouteComponentProps<{ id: string | null }> {
  id: string | null;
  loading: boolean;
  statesState: CollectionState<State>;
  townshipsState: CollectionState<Township>;
  categoriesState: CollectionState<Category>;
  listen: (id: string | null) => void;
  unlisten: () => void;
}

function compareState(a: State, b: State) {
  if (a.stateEN < b.stateEN) {
    return -1;
  }
  if (a.stateEN > b.stateEN) {
    return 1;
  }
  return 0;
}

function compareTownship(a: Township, b: Township) {
  if (a.townshipEN < b.townshipEN) {
    return -1;
  }
  if (a.townshipEN > b.townshipEN) {
    return 1;
  }
  return 0;
}

function getOptions(statesState: CollectionState<State>, townshipsState: CollectionState<Township>): CascaderOptionType[] {
  // if (statesState.status !== 'loaded' && townshipsState.status !== 'loaded') {
  //   return [];
  // }
  const states = statesState.status === 'loaded' ? statesState.data.sort(compareState) : [];
  const townships = townshipsState.status === 'loaded' ? townshipsState.data.sort(compareTownship) : [];
  return states.map(s => {
    return {
      key: s.id.toString(),
      value: s.id.toString(),
      label: s.stateEN,
      children: townships.filter(t => t.stateCode === s.code).map(t => ({
        key: t.id.toString(),
        value: t.id.toString(),
        label: t.townshipEN,
      }))
    };
  });
}

function getTree(data: Category[], parentId: string | null): TreeNode[] {
  const categorys = data.filter(d => d.parentId === parentId).sort((a, b) => a.name.localeCompare(b.name));

  return categorys.map(i => {
    return {
      key: i.id.toString(),
      value: i.id.toString(),
      title: i.name,
      children: getTree(data, i.id),
    };
  });
}
const filterTreeNodeFn =// tslint:disable-next-line:no-any
  (inputValue: string, treeNode: any) =>
    treeNode.props.title.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;

class ContactsFieldArray extends FieldArray<ContactsTableProps> { }

class CreateOrEditMerchant extends React.Component<Props> {
  componentDidMount() {
    const { id, listen } = this.props;
    listen(id);

  }

  componentWillUnmount() {
    const { unlisten } = this.props;
    unlisten();
  }

  delete = async (values: FormData, dispatch: Dispatch<AppState>) => {
    const { id } = this.props;
    const ref = firebase.firestore().collection('merchants');
    if (id) {
      const doc = ref.doc(id)
      await doc.delete()
      dispatch(toast.success('Merchant is deleted successfully.'));
      dispatch(push('/merchants'));
    }
  }

  submit = async ({ id, ...values }: FormData, dispatch: Dispatch<AppState>) => {
    const { townshipsState, statesState, categoriesState } = this.props;
    let township: Township | undefined;
    let state: State | undefined;
    let category: Category | undefined;

    const states = statesState.status === 'loaded' ? statesState.data : [];
    const townships = townshipsState.status === 'loaded' ? townshipsState.data : [];
    const allCategory = categoriesState.status === 'loaded' ? categoriesState.data : [];
    if (values.statetownship.length > 0) {
      township = townships.find(t => t.code === values.statetownship[1]);
      state = states.find(s => s.code === values.statetownship[0]);
    }

    const categories: Category[] = []
    if (values.categoryIds.length > 0) {
      values.categoryIds.forEach((categoryId) => {
        category = allCategory.find(c => c.id === categoryId);
        if (category) {
          categories.push(category)
        }
      })
    }

    const addMerchant = firebase.functions().httpsCallable('addMerchant');
    await addMerchant({
      id: id || this.props.id,
      ...values,
      township,
      state,
      categories,
    });
    dispatch(toast.success('Merchant is added successfully.'));
    dispatch(push('/merchants'));
  }

  render() {
    const { handleSubmit, submitting, loading, id, statesState, townshipsState, categoriesState } = this.props;

    const options = getOptions(statesState, townshipsState);

    const treeData = getTree(
      categoriesState.status === 'loaded' ?
        categoriesState.data : [],
      null
    );

    return (
      <Card
        loading={loading}
        title={`${id ? 'Edit' : 'Create'} Merchant`}
        bordered={true}
        bodyStyle={{ padding: 0 }}
      >
        <form onSubmit={handleSubmit(this.submit)} className="ant-form ant-form-horizontal code-box">
          <section className="last">
            <Row>
              <Col span={12}>
                {id ?
                  <FormItem label="ID" {...formItemLayout}>
                    <strong>{id}</strong>
                  </FormItem> :
                  <Field
                    name="id"
                    {...formItemLayout}
                    label="ID"
                    readOnly={!!id}
                    disabled={!!id}
                    component={TextField}
                    placeholder="Unique Identifier"
                    validate={[required, idFormat]}
                    normalize={trim}
                  />
                }
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Field
                  name="legacy"
                  label="Legacy"
                  {...formItemLayout}
                  component={CheckboxField}
                  placeholder="Legacy or Paid merchant"
                  // validate={[required]}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Field
                  name="enableSubscription"
                  label="Enable Subscription"
                  {...formItemLayout}
                  component={CheckboxField}
                  placeholder="Enable Subscription"
                  // validate={[required]}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Field
                  name="disabled"
                  label="Disabled"
                  {...formItemLayout}
                  component={CheckboxField}
                  placeholder="Active or InActive merchant"
                  // validate={[required]}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Field
                  name="businessName"
                  label="Business Name"
                  {...formItemLayout}
                  component={TextField}
                  placeholder="It is the name displayed on the app."
                  validate={[required]}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Field
                  name="contactName"
                  label={'Contact Name'}
                  {...formItemLayout}
                  component={TextField}
                  placeholder="Contact Name"
                  validate={[required]}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Field
                  name="email"
                  label="Email"
                  type="email"
                  {...formItemLayout}
                  component={TextField}
                  placeholder="Email"
                  // validate={[required]}
                  normalize={trim}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Field
                  name="phone"
                  label="Phone"
                  type="phone"
                  {...formItemLayout}
                  component={TextField}
                  placeholder="Phone"
                  validate={[required]}
                  normalize={trim}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Field
                  name="website"
                  label="Website"
                  {...formItemLayout}
                  component={TextField}
                  placeholder="Website"
                  // validate={[required]}
                  normalize={trim}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Field
                  name="fbId"
                  label="Facebook"
                  {...formItemLayout}
                  component={TextField}
                  placeholder="xxxxxxxxxxxxx"
                  // validate={[required]}
                  normalize={trim}
                  extra={`Please only enter facebook page name. Go to facebook page and click about. 
                  Copy name only from m.me/xxxxxxxxxxxxx`}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                {/* <CategoryTreeSelect
                  name="categoryIds"
                  label="Categories"
                  placeholder="Categories"
                  {...formItemLayout}
                  multiple={true}
                  categoriesState={categoriesState}
                  validate={[required]}
                /> */}
                <Field                  
                  name="categoryIds"
                  label="Categories"
                  placeholder="Categories"
                  {...formItemLayout}
                  component={TreeSelectField}
                  validate={[required]}
                  treeSelectProps={{
                    showSearch: true,
                    allowClear: true,
                    dropdownStyle: { maxHeight: 400, overflow: 'auto' },
                    treeData,
                    treeDefaultExpandAll:true,
                    filterTreeNode:filterTreeNodeFn,
                    multiple:true
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Field
                  name="address"
                  label="Address"
                  {...formItemLayout}
                  rows={4}
                  component={TextAreaField}
                  placeholder="Address"
                  validate={[required]}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Field
                  name="statetownship"
                  label="State/Township"
                  {...formItemLayout}
                  options={options}
                  component={CascaderField}
                  placeholder="State/Township"
                  validate={[required]}
                />
              </Col>
            </Row>
            <ContactsFieldArray
              name="contacts"
              component={ContactsTable}
            />
          </section>
          <section className="action-panel">
            <Button type="primary" htmlType="submit" loading={submitting} icon="save">Save</Button>
          </section>
        </form>
      </Card>
    );
  }
}

// tslint:disable-next-line:no-any
const F: any = reduxForm<FormData>({
  form: 'createOrEditMerchant',
  enableReinitialize: true,
  asyncValidate: validateIDAsync,
})(CreateOrEditMerchant);
export default connect(mapStateToProps, mapDispatchToProps)(F);



// WEBPACK FOOTER //
// ./src/merchants/forms/CreateOrEditMerchant.tsx